export const state = {
    requestHeaders: {},
};
